import styles from "../IzjavaOPristupacnosti/IzjavaOPristupacnostiPage.module.scss";

export const ObavijestOPrivatnostiPage = () => {
  const commonListStyle = {
    listStyleType: "disc",
    fontSize: "15px",
  };

  return (
    <div className={styles.about}>
      <div className={styles.title}>Obavijest o privatnosti</div>
      <p>
        Putem ove obavijesti želimo vas informirati na koji način se prikupljaju
        i obrađuju vaši osobni podaci u sklopu usluge e-Vrtići (Prijave i upisi
        u ustanove ranog i predškolskog odgoja i obrazovanja). Dječji vrtići su
        na razini svoje ustanove voditelji obrade, a Ministarstvo znanosti,
        obrazovanja i mladih na razini cijelog ranog i predškolskog odgoja i
        obrazovanja. CARNET je izvršitelj obrade osobnih podataka.
      </p>
      <div className={styles.subtitle}>Podaci koji se prikupljaju</div>
      <p>
        e-Vrtići sustav prikuplja osobne podatke djece rane i predškolske dobi,
        roditelja/skrbnika te djece i djelatnika dječjih vrtića u svrhu
        elektroničkih prijava i upisa u programe za rani i predškolski odgoj i
        obrazovanje. Proces upisa i neki od kriterija za ostvarivanje prava
        definirani su Zakonom o predškolskom odgoju i obrazovanju (NN 10/97,
        107/07, 94/13, 98/19, 57/22 i 101/23) (članak 20, stavak 8).
      </p>
      <p>
        Ustanove kao voditelji obrade za svoju ustanovu prilikom evidencije
        podataka u e-Vrtićima prikupljaju sljedeće osobne podatke iz povezanih
        registara (e-Matica, OIB registar, matične knjige, MUP registar, HZJZ,
        HZMO, MHB) ili direktno od korisnika:
      </p>
      <ul style={commonListStyle} className={styles.filled_circle_list}>
        <li>
          Osobni podaci djece rane i predškolske dobi: ime i prezime, OIB, datum
          rođenja, spol, mjesto rođenja, država rođenja, državljanstvo,
          nacionalna manjina, nacionalnost, podaci o prebivalištu/boravištu
        </li>
        <li>
          Osobni podaci djelatnika predškolskih ustanova: ime i prezime, OIB,
          broj telefona/mobitela, e-mail
        </li>
        <li>
          Osobni podaci roditelja/skrbnika: ime i prezime, OIB, datum rođenja,
          spol, mjesto rođenja, država rođenja, državljanstvo, nacionalna
          manjina, nacionalnost, odnos prema djetetu, stručna sprema, zanimanje,
          broj telefona/mobitela, e-mail, podaci o prebivalištu/boravištu
        </li>
      </ul>
      <p>
        Svi osobni podaci koriste se isključivo u svrhe radi koje su
        prikupljeni.
      </p>
      <div className={styles.subtitle}>
        Razdoblje u kojem će osobni podaci biti pohranjeni
      </div>
      <p>
        Osobni podaci čuvaju se samo onoliko koliko je potrebno za ostvarenje
        svrhe za koju su prikupljeni.
      </p>
      <p>Logovi o aktivnosti korisnika se trajno čuvaju.</p>
      <div className={styles.subtitle}>Prenošenje vaših osobnih podataka</div>
      <p>
        Prikupljeni podaci neće se prenositi u treće zemlje niti međunarodne
        organizacije niti na koji način biti dostupni trećim osobama, osim u
        slučaju kada je takva obaveza regulirana zakonom ili temeljem odluke
        voditelja obrade.
      </p>
      <div className={styles.subtitle}>
        Pristup i ažuriranje vaših osobnih podataka
      </div>
      <p>
        Korisnik u svakom trenutku ima sljedeća prava u opsegu u kojem je to
        primjenjivo:
      </p>
      <ul style={commonListStyle} className={styles.filled_circle_list}>
        <li>pravo na pristup podacima i uvid u podatke</li>
        <li>pravo na informiranost o obradi osobnih podataka</li>
        <li>pravo na prenosivost podataka</li>
        <li>pravo na podnošenje prigovora</li>
        <li>
          pravo na ispravak i promjenu osobnih podataka u slučaju ako su podaci
          nepotpuni ili netočni
        </li>
      </ul>
      <div className={styles.subtitle}>Sigurnost vaših osobnih podataka</div>
      <p>
        Poduzimaju se sve tehničke i organizacijske mjere sigurnosti kako bi se
        zaštitili vaši osobni podaci od neovlaštenog ili nezakonitog postupanja
        s njima i od njihovog slučajnog gubitka, uništenja ili izmjena.
      </p>
      <div className={styles.subtitle}>
        Kontaktni podaci službenika za zaštitu podataka
      </div>
      <p>
        Za obrade koje provodi dječji vrtić obratite se službeniku za zaštitu
        podataka relevantnog dječjeg vrtića. Ministarstvo znanosti, obrazovanja
        i mladih je sukladno relevantnim propisima imenovalo Službenika za
        zaštitu podataka kojega možete kontaktirati prema podacima na web adresi{" "}
        <a href="https://mzom.gov.hr/pristup-informacijama/zastita-osobnih-podataka/482">
          https://mzom.gov.hr/pristup-informacijama/zastita-osobnih-podataka/482
        </a>{" "}
        za sva pitanja povezana s obradom vaših osobnih podataka ili
        ostvarivanje svojih prava na zaštitu osobnih podataka za obrade koje
        provodi Ministarstvo znanosti, obrazovanja i mladih.
      </p>
      <div className={styles.subtitle}>Nadzorno tijelo</div>
      <p>
        Ako imate prigovor vezano uz vlastita prava možete uputiti primjedbu
        nadzornom tijelu za zaštitu osobnih podataka, odnosno Agenciji za
        zaštitu osobnih podataka (AZOP).
      </p>
      <p>Agencija za zaštitu osobnih podataka</p>
      <p>
        <a href="https://azop.hr/">https://azop.hr/</a>
      </p>
    </div>
  );
};
